import React from 'react';
import './Footer.css';
import White from '../../assets/logoWhite.svg';
import Phone from '../../assets/icon-phone.svg';
import Email from '../../assets/icon-email.svg';
import Facebook from '../../assets/facebook.svg';
import Instagram from '../../assets/instagram.svg';
import Twitter from '../../assets/twitter.svg';

function Footer() {
    return (
        <footer>
            <img className='Logo' src={White} alt='logo in White' />
            <div className='footer-content'>
                <div>
                    <div className='footer-contact'>
                        <img src={Phone} alt='phone icon' />
                        <p> Phone: +1-543-123-4567</p>
                    </div>
                    <div className='footer-contact'>
                        <img src={Email} alt='email icon' />
                        <p>example@fylo.com</p>
                    </div>
                </div>
                <div className='footer-list'>
                    <ul>
                        <li>
                            <a href='https://reactjs.org' rel='noopener noreferrer'>
                            {' '}
                            About Us{' '}
                            </a>
                        </li>
                        <li>
                            <a href='https://reactjs.org' rel='noopener noreferrer'>
                            {' '}
                            Jobs{' '}
                            </a>
                        </li>
                        <li>
                            <a href='https://reactjs.org' rel='noopener noreferrer'>
                            {' '}
                            Press{' '}
                            </a>
                        </li>
                        <li>
                            <a href='https://reactjs.org' rel='noopener noreferrer'>
                            {' '}
                            Blog{' '}
                            </a>
                        </li>
                    </ul>
                </div>
                <div className='footer-list'>
                    <ul>
                        <li>
                            <a href='https://reactjs.org' rel='noopener noreferrer'>
                            {' '}
                            Contact Us{' '}
                            </a>
                        </li>
                        <li>
                            <a href='https://reactjs.org' rel='noopener noreferrer'>
                            {' '}
                            Terms{' '}
                            </a>
                        </li>
                        <li>
                            <a href='https://reactjs.org' rel='noopener noreferrer'>
                            {' '}
                            Privacy{' '}
                            </a>
                        </li>
                    </ul>
                </div>
                <div className='footer-social-media'>
                    <img src={Facebook} alt='facebook icon' />
                    <img src={Twitter} alt='twitter icon' />
                    <img src={Instagram} alt='instagram icon' />
                </div>
            </div>
            <div>
                <p className='attribution'>
                    Coded by Rio Cantre
                </p>
            </div>
        </footer>
    );
}

export default Footer
